import { showFlashNotification } from 'redux/modules/flashNotification';

const Eloquent = window.Eloquent;

/**
 * Intercept all api calls to site backend and handle errors
 * @param {Function} dispatch - redux store dispatch function
 */
export default function apiInterceptor(dispatch) {
    Eloquent.addResponseInterceptor((resp) => {
        if (!resp.isOk || resp.status >= 500) {
            const endpoint = resp.request.responseURL.split('/').pop();
            const endpointExceptions = ['login', 'reg', 'logout', 'email', 'me'];

            if (resp.status === 401 && !endpointExceptions.includes(endpoint)) {
                dispatch(showFlashNotification({ text: 'You are not logged in!', isWarning: true }));
            }

            let error = new Error(resp.statusText);

            error.response = resp;
            throw error;
        }
    });
}
